import { FC } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { twMerge } from 'tailwind-merge';
import { AreaTooltipContent } from '../common';
import { DonutChartItem } from './types';

type DonutChartProps = {
  data: DonutChartItem[];
  className?: string;
};

export const DonutChart: FC<DonutChartProps> = ({ data, className }) => {
  return (
    <div className={twMerge('flex size-fit items-center justify-center', className)}>
      <ResponsiveContainer>
        <PieChart>
          <Tooltip content={AreaTooltipContent} />
          <Pie
            data={data}
            nameKey='name'
            dataKey='value'
            innerRadius='50%'
            outerRadius='100%'
            startAngle={90}
            endAngle={450}
            animationDuration={2000}
            animationBegin={0}
            stroke='none'
            tabIndex={-1}
          >
            {data.map((entry) => (
              <Cell key={`${entry.name}-${entry.value}`} fill={entry.color} className='focus:outline-0' />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
